import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FolderChildren } from '@core/util/folder';
import { DefaultFolder, Document, Folder } from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { MergedMatterFolderSelectors } from '@state/global/documents/merged-folders';
import { Observable } from 'rxjs/internal/Observable';

export interface FolderMoveDialogData {
	document: Document;
	rootLabel?: string;
}

export type FolderMoveDialogClose = string | null;

interface MoveDocumentFolder extends Folder {
	children: number;
}

const DefaultMoveDocumentFolder: MoveDocumentFolder = {
	...DefaultFolder,
	children: 0,
};

@UntilDestroy()
@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-move-document-dialog',
	templateUrl: 'folder-move-dialog.component.html',
	standalone: false,
})
export class FolderMoveDialogComponent implements OnInit {
	currentFolderId: string;
	oldFolderId: string;
	folders: MoveDocumentFolder[];
	@Select(MergedMatterFolderSelectors.getAll) folders$: Observable<Folder[]>;

	rootLabel = 'Root';

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: FolderMoveDialogData,
		private dialogRef: MatDialogRef<FolderMoveDialogComponent>,
	) {}

	ngOnInit(): void {
		this.currentFolderId = '';
		this.folders$.pipe(untilDestroyed(this)).subscribe((folders) => {
			this.folders = folders.map((folder) => ({
				...DefaultMoveDocumentFolder,
				...folder,
				children: FolderChildren(folder.id, folders).length,
			}));
			this.folders.sort((prev, curr) => (prev.title < curr.title ? -1 : 1));
			this.currentFolderId =
				this.folders.find((folder) => folder.id === this.data.document.folderId)
					?.id ||
				this.data.document.folderId ||
				'';
			this.oldFolderId = this.currentFolderId;
		});
		const { rootLabel } = this.data;
		if (rootLabel) {
			this.rootLabel = rootLabel;
		}
	}

	cancelModal(): void {
		this.dialogRef.close(null);
	}

	moveDocument(): void {
		this.dialogRef.close(this.currentFolderId);
	}
}
